import { GlobalReportsBreadcrumbs } from '@app/modules/audit/modules/global-audit/components/GlobalReportsBreadcrumbs';
import { Report } from '@mi-front/core';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import React from 'react';
import { Page } from '../../../../../../components/page/Page';

export function BaseReportPage({
  report,
  children,
  headerActions,
}: {
  report: Report;
  children: React.ReactNode;
  headerActions?: React.ReactNode;
}) {
  const title = report.name;

  return (
    <Page htmlTitle={title}>
      <Page.Header
        title={title}
        icon={<DescriptionOutlinedIcon />}
        breadcrumbs={<GlobalReportsBreadcrumbs showCreatedReports reportType={report.type} />}
        actions={headerActions}
      />
      <Page.Content>{children}</Page.Content>
    </Page>
  );
}
